import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, Mail, Shield, FileText, Users, Trophy } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-card border-t border-border/40 mt-12 pb-20 md:pb-0" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3 group">
              <Flame className="w-6 h-6 text-primary" strokeWidth={2.5} />
              <span className="font-heading text-xl font-extrabold tracking-tight text-white">ZNAJDOWNIK</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Społeczność łowców okazji. Znajdź najlepsze promocje, dziel się znaleziskami i zarabiaj Zorki!
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-white mb-3">Nawigacja</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">Gadulec</Link></li>
              <li><Link to="/wachalski" className="text-sm text-muted-foreground hover:text-primary transition-colors">Wąchalski AI</Link></li>
              <li><Link to="/blog" className="text-sm text-muted-foreground hover:text-primary transition-colors">Blog</Link></li>
              <li><Link to="/leaderboard" className="text-sm text-muted-foreground hover:text-primary transition-colors">Ranking</Link></li>
            </ul>
          </div>

          {/* For Users */}
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-white mb-3">Dla Użytkowników</h3>
            <ul className="space-y-2">
              <li><Link to="/submit" className="text-sm text-muted-foreground hover:text-primary transition-colors">Dodaj okazję</Link></li>
              <li><Link to="/referral" className="text-sm text-muted-foreground hover:text-primary transition-colors">Polecaj i zarabiaj</Link></li>
              <li><Link to="/profile" className="text-sm text-muted-foreground hover:text-primary transition-colors">Twój profil</Link></li>
              <li><Link to="/auth" className="text-sm text-muted-foreground hover:text-primary transition-colors">Zaloguj się</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-white mb-3">Informacje</h3>
            <ul className="space-y-2">
              <li className="text-sm text-muted-foreground flex items-center gap-1.5">
                <Mail className="w-3.5 h-3.5 text-primary" /> kontakt@znajdownik.pl
              </li>
              <li><Link to="/polityka-prywatnosci" className="text-sm text-muted-foreground hover:text-primary transition-colors">Polityka prywatności</Link></li>
              <li><Link to="/regulamin" className="text-sm text-muted-foreground hover:text-primary transition-colors">Regulamin</Link></li>
            </ul>
            <div className="flex items-center gap-2 mt-4">
              <span className="text-zorki font-heading font-bold text-sm">ZORKI</span>
              <span className="text-xs text-muted-foreground">- nasza waluta społeczności</span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border/30 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Znajdownik.pl - Łowca Okazji. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-xs text-muted-foreground">
            Niektóre linki mogą być linkami afiliacyjnymi. Korzystając z nich wspierasz portal.
          </p>
          <p className="text-xs text-muted-foreground">
            wykonanie{' '}
            <a
              href="https://www.zens.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-primary/80 transition-colors"
              data-testid="zens-it-link"
            >
              Zens IT
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
